module.exports = __webpack_public_path__ + "img/reading.de873016.jpg";